<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { IconName } from '~/components/atoms/icon/Icon.vue'

const config = useRuntimeConfig()
const route = useRoute()

const { t } = useI18n()

const url = `${config.public.frontendBaseUrl}${route.fullPath}`
const networks = {
  facebook: {
    name: 'Facebook',
    icon: 'facebook',
    url: `https://facebook.com/sharer/sharer.php?u=${url}`,
  },
  twitter: {
    name: 'Twitter',
    icon: 'twitter',
    url: `https://twitter.com/share?url=${url}`,
  },
  linkedin: {
    name: 'Linkedin',
    icon: 'linkedin',
    url: `https://linkedin.com/sharing/share-offsite/?url=${url}`,
  },
} satisfies Record<string, { name: string; icon: IconName; url: string }>
</script>

<template>
  <div v-animate="{ animation: 'vertical-reveal', cluster: true }" class="share">
    <span v-animate="{ animation: 'vertical-reveal' }" class="label f-bold">{{ t('share') }}</span>
    <ul class="items cul">
      <li v-for="(item, index) in networks" :key="index" v-animate="{ animation: 'vertical-reveal' }" class="item">
        <NuxtLink class="item" :to="item.url" target="_blank">
          <Icon :name="item.icon" />
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.share {
  padding-top: 24px;

  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: space-between;

  border-top: 1px solid var(--c-line-medium);
}
.label {
  color: var(--c-primary);
}
.items {
  display: flex;
  gap: 15px;
}
.item {
  --color: var(--c-textlink);
  --hover-color: var(--c-blue-rollover);

  display: block;
  color: var(--color);

  @include transitions(color, transform);
  @include fluid(--size-icon, 28px, 32px);

  @include hover {
    color: var(--hover-color);
    transform: scale(0.95);
  }

  svg {
    width: var(--size-icon);
    height: var(--size-icon);
  }
}
</style>
